import { ActionButtons, TitleDescription } from "components/custom"
import { DataTable, DateFormat, Modal, Text } from "components/common"
import { useDeleteNoteMutation, useLazyGetInventoryNotesQuery } from "features/inventory/api"
import { useEffect, useMemo, useRef, useState } from "react"

import getPrivilege from "utils/privileges/privileges"
import { useSelector } from "react-redux"
import { localisedValue } from "utils"
import { useTranslation } from "react-i18next"
import { t } from "i18next"

const columns = () => [
  { title: t("Note"), dataIndex: "note", key: "note", width: 450 },
  { title: t("Added By"), dataIndex: "addedBy", key: "addedBy" },
  { title: t("Updated By"), dataIndex: "updatedBy", key: "updatedBy" },
  { title: t("Actions"), dataIndex: "actions", key: "actions" },
]

const InventoryNotes = ({ inventoryId }) => {
  const { t } = useTranslation()
  const [
    getInventoryNotes,
    { data: inventoryNotes, isFetching: isFetchingInventoryNotes, error: errorInventoryNotes },
  ] = useLazyGetInventoryNotesQuery()
  const [deleteNote, { isLoading, error, isError }] = useDeleteNoteMutation()
  const [noteId, setNoteId] = useState()
  const deleteModalRef = useRef()
  const privileges = useSelector(state => state.app.privileges)

  useEffect(() => {
    getInventoryNotes(inventoryId)
  }, [inventoryId])

  const getActionButtons = note => {
    return [
      {
        key: "deleteRecord",
        icon: "FiTrash2",
        color: "#E83A3A",
        content: t("Delete Record"),
        onClick: () => {
          setNoteId(note.id)
          deleteModalRef.current.setVisible(true)
        },
        disabled: !getPrivilege(["can_delete_inventory_notes"], privileges),
      },
    ]
  }

  const onDeleteNote = async id => {
    const response = await deleteNote(id)
    if (response?.data) {
      deleteModalRef.current.setVisible(false)
    }
  }

  const inventoryNotesData = useMemo(() => {
    return (
      inventoryNotes &&
      inventoryNotes?.notes?.map((e, index) => {
        return {
          key: index,
          note: (
            <Text style={{ display: "block", whiteSpace: "break-spaces" }}>
              {localisedValue({ key: "note", object: e })}
            </Text>
          ),
          addedBy: (
            <TitleDescription
              title={localisedValue({ key: "name", object: e?.AddedBy }) || "-"}
              gapSpace={4}
              description={<DateFormat date={e.createdAt} dateClassName="" />}
            />
          ),
          addedOn: <DateFormat date={e.createdAt} icon={null} />,
          updatedBy: (
            <TitleDescription
              title={localisedValue({ key: "name", object: e?.UpdatedBy }) || "-"}
              gapSpace={4}
              description={<DateFormat date={e?.updatedAt} dateClassName="" />}
            />
          ),
          updatedOn: <DateFormat date={e?.updatedAt} icon={null} />,
          actions: (
            <ActionButtons list={getActionButtons(e)} animate={false} style={{ "--hover-displacement": "-24px" }} />
          ),
        }
      })
    )
  }, [inventoryNotes])

  return (
    <>
      <div style={{ paddingTop: 12 }}>
        <DataTable
          columns={columns()}
          data={inventoryNotesData}
          noUrlPush={true}
          stickyOffset={-25}
          loading={isFetchingInventoryNotes}
          error={errorInventoryNotes}
        />
      </div>
      <Modal
        onOk={() => onDeleteNote(noteId)}
        onCancel={() => {
          deleteModalRef.current.setVisible(false)
          setNoteId()
        }}
        okText={t("Confirm")}
        width={500}
        ref={deleteModalRef}
        title={t("Delete Note")}
        onOkProps={{ danger: "danger", loading: isLoading }}
        footerAlert={isError && error}
      >
        <Text>{t("Are you sure you want to delete")}.</Text>
      </Modal>
    </>
  )
}

export default InventoryNotes
